var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allPage"},[_c('new-header'),_c('div',{staticClass:"VocContent"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }